import {
  ReturnProcessStatusSchema,
  ReturnReadyStatusSchema,
} from "@redotech/redo-model/returns/temporal-status";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const workflowTypes = ["ready", "processing"] as const;
export type WorkflowType = (typeof workflowTypes)[number];

const WorkflowStatusInputSchema = z.object({
  returnId: zExt.objectId(),
  workflowType: createEnum(workflowTypes),
});

const WorkflowStatusOutputSchema = z.object({
  workflowStartTime: z.date().nullish(),
  activityStatuses: z.union([
    z.array(ReturnReadyStatusSchema),
    z.array(ReturnProcessStatusSchema),
  ]),
  isWorkflowRunning: z.boolean().optional(),
});

export const WorkflowStatus = WorkflowStatusOutputSchema;
export type WorkflowStatus = z.infer<typeof WorkflowStatus>;

export const getWorkflowStatus = unaryStreamRpc({
  name: "getWorkflowStatus",
  input: WorkflowStatusInputSchema,
  output: WorkflowStatusOutputSchema,
});
